"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSectionConfig = void 0;
var defaultSectionConfig = {
    dark: false,
    titleConfig: {
        align: 'center',
        size: 3,
        margin: {
            desktop: '0 0 1em',
            tablet: '0 0 1em',
            mobile: '0 0 1em'
        }
    },
    descriptionConfig: {
        align: 'center',
        margin: {
            desktop: '0 0 40px',
            tablet: '0 0 40px',
            mobile: '0 0 30px'
        }
    }
};
exports.defaultSectionConfig = defaultSectionConfig;
//# sourceMappingURL=Kontakt.js.map